import { useLightMode } from '@/hooks/useLightMode'
import { useTranslation } from 'react-i18next'

import { Alert, Box, Modal } from '@hivewatch/dark'

import { tVar } from '@/utils/i18n'

interface DarkConfirmGatewayRestartDialogIProps {
  isOpen: boolean
  isRestartLoading: boolean
  onClose: () => void
  onConfirm: () => void
  gatewayName?: string
  componentName?: string
}

/**
 * Rebrand variant of {@link ConfirmGatewayRestartDialog} built on the dark
 * Modal with destructive save treatment, following the ArchiveRuleModal
 * precedent. Opened from `DarkGatewayDetailsModal` only; the legacy details
 * modal keeps the legacy dialog.
 */
export const DarkConfirmGatewayRestartDialog = ({
  isOpen,
  isRestartLoading,
  onClose,
  onConfirm,
  gatewayName,
  componentName,
}: DarkConfirmGatewayRestartDialogIProps) => {
  const { t } = useTranslation()
  const colorScheme = useLightMode()

  return (
    <Modal
      colorScheme={colorScheme}
      isOpen={isOpen}
      isSaveDestructive
      isSaveLoading={isRestartLoading}
      onClose={onClose}
      onSave={onConfirm}
      saveButtonLabel={t('gateways:crud_restart_dialog_confirm')}
      showCancelButton
      size='compact'
      title={t('gateways:crud_restart_dialog_title')}
    >
      <Box data-testid='DarkConfirmGatewayRestartDialog:body'>
        {tVar(t, 'gateways:crud_restart_dialog_body', {
          componentName,
          gatewayName,
        })}
      </Box>
      <Box mt='16px'>
        <Alert
          colorScheme={colorScheme}
          description={t('gateways:crud_restart_dialog_warning_body')}
          title={t('common:warning_title')}
          variant='warning'
        />
      </Box>
    </Modal>
  )
}
